import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '@/lib/route-guards';
import { warm, warmBackground } from '@/api/loaders';
import {
  campaignsList,
  pixelsList,
  productionsList,
  productionsRunningSummary,
  reportingByProduction,
  venuesList,
} from '@/api/resources';
import { useSetViewShim } from '@/lib/use-set-view';
import { ProductionsView } from '@/screens/productions';

export const Route = createFileRoute('/backend/productions')({
  beforeLoad: requireSession,
  // Block only on the rows this screen is ABOUT; warm its companions in the
  // background. Awaiting everything would trade one problem for another —
  // no empty flash, but a cold load that shows the previous route until the
  // slowest query lands. The table renders its own loading state for
  // whatever is still in flight.
  loader: ({ context }) => {
    warmBackground(
      context.queryClient,
      venuesList({}),
      campaignsList({}),
      pixelsList({}),
      reportingByProduction({}),
      productionsRunningSummary(undefined),
    );
    return warm(context.queryClient, productionsList({}));
  },
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  return <ProductionsView setView={setView}  />;
}
